import $ from "jquery";

import article from '../templates/pages/article';
import frontpage from '../templates/pages/frontpage';
// import content from '../templates/pages/content';
import header from '../templates/body/header';
import footer from '../templates/body/footer';
import list from '../templates/pages/list';
import { getApiWarnings } from "./warnings";
// import nav from './templates/body/nav';
// import show404 from '../templates/pages/status_404.js';
// import headerMenu from './templates/body/header_menu.js';
import { headerNav, storeNav, navPage } from "./nav.js"
import fullsearch from '../templates/pages/search';
import event from '../templates/pages/event.js';
import "fantdu/dist/fantdu.min";
import { skjema_page } from "./skjema.js";
import { convertJSON } from "./convertjson.js";
import { cookieRead, cookieDelete } from "./cookie_control";

import { importer } from "./importer";


export const startMeUp = (data, e) => {


    let meta = {};
    let app_all_meta;

    data.result.applications.forEach((appMeta) => {
        // console.log(appMeta);
        if (appMeta.application.applicationServiceLocalId === "aim") {
            meta = JSON.parse(decodeURIComponent(appMeta.metaData));
            app_all_meta = appMeta;
        }
        else if (appMeta.application.applicationServiceLocalId === "KariAdm") {
            meta = JSON.parse(decodeURIComponent(appMeta.metaData));
            app_all_meta = appMeta;
        }
    })

    // console.log(meta);
    const aimMeta = meta.aim;

    window.globalconfig = aimMeta;
    // console.log(aimMeta);

    let maincontent = "";
    const template = getPageUrl().template;
    const client = $.extend("", { template: template }, aimMeta); //response[0]["prokom"], response[0][kommune]

    client.full = data;
    client.application = app_all_meta;

    // console.log("client", client);
    window.client = client;

    window.searchEngine = client.searchEngine || "https://aim.prokom.haive.cloud";

    document.documentElement.setAttribute('lang', (client.lang || "nb"));
    //console.log(document.documentElement.getAttribute('lang'));

    if (client.favicon) {
        function setFavicons(favImg) {
            let headTitle = document.querySelector('head');
            let setFavicon = document.createElement('link');
            setFavicon.setAttribute('rel', 'shortcut icon');
            setFavicon.setAttribute('href', favImg);
            headTitle.appendChild(setFavicon);
        }
        setFavicons(client.favicon);
    }

    sessionStorage.setItem("config", JSON.stringify(client));
    let cssVariables = {};

    $.each(client.css, function(nr, obj) {
        document.documentElement.style.setProperty('--' + obj.prop, obj.value)
        cssVariables[obj.prop] = obj.value;
    });

    if (client.style) {
        // console.log("test", client.style);
        for (const [prop, value] of Object.entries(client.style)) {
            document.documentElement.style.setProperty('--' + prop, value)
            // console.log(prop, value);
            cssVariables[prop] = value;
        }
    }
    // console.log("cssvar",cssVariables);

    // CHECK LOGGIN
    if (sessionStorage.getItem("fromcms") === "true" && getUrlAttr("preview")) {
        //console.log("yeay");
        sessionStorage.setItem("loginRedirect", window.location.href);
        var config = {
            authority: "https://identity.prokom.no",
            client_id: "AimPreviewClient",
            redirect_uri: location.origin + "/callback.html",
            response_type: "code",
            scope: "openid profile aim_api",
            post_logout_redirect_uri: location.origin,
        };

        var mgr = new Oidc.UserManager(config);
        mgr.getUser().then(function(user) {
            if (user) {
                mgr.getUser().then(function(user) {
                    sessionStorage.setItem("access_token", user.access_token);
                });

                function logout() {
                    mgr.signoutRedirect();
                }
            }
            else {
                mgr.signinRedirect();
            }
        });

        $("body").append(`
                <div class="alert alert-warning fixed-bottom mb-0" role="alert">
                    <div class="container"><div class="row"><div class="col-12">
                        Du er nå på forhåndsvisning av siden. Klikk <a href="${location.origin}${location.pathname}">her</a> for å se live versjon.
                    </div></div></div>
                </div>`);
    }


    //sets header
    header(client);

    console.log("startmeup: after header before load", client.clientId);

    let json = window.apiUrl + "/api/PublicContentApi/contentcountbycategory/" + client.clientId;
    let menucategory = window.apiUrl + "/api/PublicContentApi/menucategory/" + client.clientId;

    console.log(json);
    fetch(json).catch(response => response.json())
        .then(data => {

            console.log("json", data);

        })
    console.log(menucategory);
    fetch(menucategory).catch(response => response.json())
        .then(data => {
            console.log("menucategory", data);
        })

    $.when(
        $.getJSON(menucategory),
        $.getJSON(json)
    ).done(function(navdata, articleCount) {
        storeNav(navdata[0], articleCount[0]);
        $(".fullnav__main").html(headerNav());
        switch (client.template) {

            case "nav":
                maincontent = navPage();
                break;
            case "skjema":
                maincontent = skjema_page(client);
                break;
            case "article":
                maincontent = article(client);
                break;
            case "blokk":
                maincontent = article(client);
                break;
            case "fokus":
                maincontent = article(client);
                break;
            case "artikkel":
                maincontent = article(client);
                break;
            case "enhet":
                maincontent = article(client);
                break;
            case "unit":
                maincontent = article(client)
                break;
            case "sok":
                maincontent = fullsearch(getPageUrl().contentid);
                break;
            case "search":
                maincontent = fullsearch(getPageUrl().contentid);
                break;
            case "frontpage":
                maincontent = frontpage(client, client.clientId);
                break;
            case "event":
                maincontent = event(client);
                break;
            case "event/":
                maincontent = event(client);
                break;
            case "list":
                maincontent = list(client);
                break;
            case "liste":
                maincontent = list(client);
                break;
            case "convertjson":
                maincontent = convertJSON();
                break;
            default:
                maincontent = article(client);

        }

        $("#maincontent").html(maincontent);

        if (client.template === "frontpage" || client.template === "nav")
            getApiWarnings();

    });

    // console.log(cssVariables)

    $("#footer").html(footer);

    cssVars({
        watch: true,
        variables: cssVariables
    });

    FantDu.startTrace("ssp_fantdu", client.nameId, e);

    // console.log("cookie", cookieRead("RuntimeMode"));

    if (cookieRead("RuntimeMode") == "dev") {
        $("body").append(`
                <div class="alert alert-primary fixed-bottom mb-0" role="alert">
                    Du ser nå siden i <strong><u>Dev</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
                </div>`);
    }
    
    if (cookieRead("RuntimeMode") == "qa") {
        $("body").append(`
                <div class="alert alert-primary fixed-bottom mb-0" role="alert">
                    Du ser nå siden i <strong><u>QA</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
                </div>`);
    }

    if (cookieRead("RuntimeMode") == "staging") {
        $("body").append(`
                <div class="alert alert-warning fixed-bottom mb-0" role="alert">
                    Du ser nå siden i <strong><u>Staging</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
                </div>`);
    }

    if (cookieRead("RuntimeMode") == "release") {
        $("body").append(`
                <div class="alert alert-warning fixed-bottom mb-0" role="alert">
                    Du ser nå siden i <strong><u>Release</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
                </div>`);
    }

    if (cookieRead("RuntimeMode") == "prod") {
        $("body").append(`
                <div class="alert alert-success fixed-bottom mb-0" role="alert">
                    Du ser nå siden i <strong><u>Prod</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
                </div>`);
    }

    $("body").on("click", ".cookie-delete", function() {
        cookieDelete("RuntimeMode");
    })
}
